import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-token-placement-modal',
    templateUrl: './token-placement-modal.component.html',
    styleUrls: ['./token-placement-modal.component.scss'],
    standalone: false
})
export class TokenPlacementModalComponent implements OnInit {

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
    }

    close() {
        this.activeModal.close('closed');
    }

}
